/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_NoteInputs */

const en_simple_mulai_note = /** @type {(inputs: Simple_Mulai_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure which route? Start with the plan — these options come back at the end.`)
};

const id_simple_mulai_note = /** @type {(inputs: Simple_Mulai_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum yakin jalur mana? Mulai saja dari rencananya — pilihan ini muncul lagi di akhir.`)
};

/**
* | output |
* | --- |
* | "Not sure which route? Start with the plan — these options come back at the end." |
*
* @param {Simple_Mulai_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_note = /** @type {((inputs?: Simple_Mulai_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_note(inputs)
	return en_simple_mulai_note(inputs)
});